import Inspector from './inspector';

const { InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { variant, background, image, margin } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`locations ${background} ${variant} ${margin}`}>
        {image && (
          <img
            className="locations-bg"
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
          />
        )}
        <div className="Container">
          <InnerBlocks
            template={[
              [
                'base/heading-sumicity',
                { titleTag: 'h2', variant: 'title-6', color: 'color-white' },
              ],
              [
                'base/paragraph-sumicity',
                {
                  containerized: false,
                  color: 'color-white',
                  margin: 'margin-base',
                },
              ],
              ['app/locate-selector'],
            ]}
          />
        </div>
      </section>
    </>
  );
};

export default Edit;
